export default __webpack_public_path__ + "static/media/logo-collapsed.a3423e90.svg";